/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Team } from './Team';
import {
    TeamFromJSON,
    TeamFromJSONTyped,
    TeamToJSON,
    TeamToJSONTyped,
} from './Team';
import type { Client } from './Client';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
    ClientToJSONTyped,
} from './Client';

/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    id: number;
    /**
     * 
     * @type {Client}
     * @memberof User
     */
    client?: Client;
    /**
     * 
     * @type {Team}
     * @memberof User
     */
    team?: Team;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    role?: UserRoleEnum;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    is_non_sso_user?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    profile_photo_path?: string | null;
}


/**
 * @export
 */
export const UserRoleEnum = {
    NgInactive: 'ng_inactive',
    NgUser: 'ng_user',
    NgSystemAdmin: 'ng_system_admin',
    NgSupervisor: 'ng_supervisor',
    NgServiceAccount: 'ng_service_account'
} as const;
export type UserRoleEnum = typeof UserRoleEnum[keyof typeof UserRoleEnum];


/**
 * Check if a given object implements the User interface.
 */
export function instanceOfUser(value: object): value is User {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function UserFromJSON(json: any): User {
    return UserFromJSONTyped(json, false);
}

export function UserFromJSONTyped(json: any, ignoreDiscriminator: boolean): User {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'client': json['client'] == null ? undefined : ClientFromJSON(json['client']),
        'team': json['team'] == null ? undefined : TeamFromJSON(json['team']),
        'name': json['name'],
        'email': json['email'],
        'role': json['role'] == null ? undefined : json['role'],
        'is_non_sso_user': json['is_non_sso_user'] == null ? undefined : json['is_non_sso_user'],
        'profile_photo_path': json['profile_photo_path'] == null ? undefined : json['profile_photo_path'],
    };
}

export function UserToJSON(json: any): User {
    return UserToJSONTyped(json, false);
}

export function UserToJSONTyped(value?: User | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'client': ClientToJSON(value['client']),
        'team': TeamToJSON(value['team']),
        'name': value['name'],
        'email': value['email'],
        'role': value['role'],
        'is_non_sso_user': value['is_non_sso_user'],
        'profile_photo_path': value['profile_photo_path'],
    };
}

